/**
 * 0  禁用状态
 * 1  启用状态
 */
export enum MoxibustionStatusEnum {
    Enable = 0,
    Disable = 1,
}
